import {AddressServiceName} from "../../../../utils/names/serviceNames";
import {AddressService} from "../../../service/address.service";
import {Address} from "../../../model/Address";

export class AddressControlVerifyController {
    static instance = {
        template: require('./address-control-verify.html'),
        controller: [AddressServiceName, AddressControlVerifyController],
        bindings: {
            address: '='
        }
    };

    constructor(private addressService: AddressService) {
    }

    private address: Address;

    verifyAddress = () => {
        if (this.isInvalidAddress()) {
            this.addressService.verifyAddress(this.address)
                .then(resp => {
                    if (resp.status == 200) {
                        this.address = resp.data;
                    }
                })
        }
    };

    private isInvalidAddress() {
        return this.address
            && this.address.verification
            && !this.address.verification.valid;
    }
}